export function normalizeTimeEntryId(rawTimeEntryId) {
  const timeEntryId = Number(rawTimeEntryId);
  return Number.isInteger(timeEntryId) && timeEntryId > 0 ? timeEntryId : null;
}
